import {
  cloneElement,
  createContext,
  ReactElement,
  useCallback,
  useContext,
  useState,
} from 'react';

export interface GlobalComponentsContextType {
  union: (id: string, component: ReactElement) => void;
  remove: (id: string) => void;
}

const defaultState: GlobalComponentsContextType = {
  union: () => {
    /* */
  },
  remove: () => {
    /* */
  },
};

const GlobalComponentsContext = createContext(defaultState);

export function useGlobalComponentsContext() {
  return useContext(GlobalComponentsContext);
}
export type GlobalComponentsProviderProps = {
  children: ReactElement;
};
export function GlobalComponentsProvider({
  children,
}: GlobalComponentsProviderProps) {
  const [components, setComponents] = useState<{ [key: string]: ReactElement }>(
    {},
  );
  const union = useCallback((id: string, component: ReactElement) => {
    setComponents((prevComponents) => {
      if (Object.keys(prevComponents).includes(id)) {
        return prevComponents;
      }
      return { ...prevComponents, [id]: component };
    });
  }, []);
  const remove = useCallback((id: string) => {
    setComponents((prevComponents) => {
      if (!Object.keys(prevComponents).includes(id)) {
        return prevComponents;
      }
      const { [id]: removed, ...rest } = prevComponents;
      return rest;
    });
  }, []);
  return (
    <GlobalComponentsContext.Provider
      value={{
        union,
        remove,
      }}
    >
      <>
        {children}
        {Object.entries(components).map(([id, component]) =>
          cloneElement(component, { key: id }),
        )}
      </>
    </GlobalComponentsContext.Provider>
  );
}
